import "./_style.scss";
import { Box } from "@mui/material";
import { useContext, useEffect, useMemo, useState, useRef } from "react";
import { useNavigate } from "react-router";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkStepper from "../../components/atoms/TkStepper";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { httpAPI_RET005 } from "./api/request";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import { IAPI_RET005_Request } from "../../type/apiType";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import {
  fakeTableList,
  infoManualRelationship1,
  infoManualRelationship2,
  infoManualRelationship3,
  infoManualRelationship4,
  infoManualRelationship5,
  infoManualRelationship6,
  schema,
  steps,
} from "./parts";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { API_RET005_BuildReqParams } from "../../utils/buildRequestParams";
import _ from "lodash";
import { FormClassRetire, FormKbn, Relationship } from "../../assets/data/Constants";

/**
 * SCRR411125 退職手当金受領者の変更手続き（添付書類の登録）
 * @return SCRR411125
 */
const SCRR411125 = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [infoManual, setInfoManual] = useState("");
  const [stateTableList, setStateTableList] = useState<any>([]);
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const context = businessState.job_41;
  const [latestFileList, setLatestFileList] = useState<any>([]);
  const stateFakeTableListRef = useRef(_.cloneDeep(fakeTableList));
  const stateFakeTableList = stateFakeTableListRef.current;

  // 機構判定
  const isKiKo =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const contractorNo = isKiKo
    ? businessState.common?.contractorNo
    : state.authInfo?.contractorNo;

  useEffect(() => {
    // 持回り情報を初期表示する
    let resArr = [...stateFakeTableList];
    setLatestFileList(context?.fileList ? context?.fileList : latestFileList);

    //「死亡診断書」又は「死体検案書」（写）
    let deathOrAutopsyReport = resArr.find(
      (item) => item.keyword === "deathOrAutopsyReport"
    )!;
    //内縁関係についての「生計維持に関する調査書」（様式１１号）
    let marriageReport = resArr.find(
      (item) => item.keyword === "marriageReport"
    )!;

    //職員の死亡当時の世帯員の状況を明らかにできる「住民票の謄本」
    let certifiedCertificateResidence = resArr.find(
      (item) => item.keyword === "certifiedCertificateResidence"
    )!;
    //その他、事実上の配偶者であることを証明する書類
    let documentCertifyingSpouse = resArr.find(
      (item) => item.keyword === "documentCertifyingSpouse"
    )!;

    //職員の死亡当時、主として職員の収入により生計を維持していた親族がいることを証する「生計維持に関する調査書」（様式１１号）
    let yesLivelihoodInvestForm = resArr.find(
      (item) => item.keyword === "yesLivelihoodInvestForm"
    )!;

    //職員の死亡当時、主として職員の収入により生計を維持していた親族がいないことを証する「生計維持に関する調査書」（様式１１号）
    let noLivelihoodInvestForm = resArr.find(
      (item) => item.keyword === "noLivelihoodInvestForm"
    )!;

    let message = "";
    function addMessage(str: string) {
      if (!message.includes(str)) {
        message += str;
      }
    }

    //入出力項目.添付が必要な書類を不足ファイルのみを表示する
    if (context?.missingFileList) {
      context?.missingFileList.forEach((file: any) => {
        if (file.missingFormKbn !== "6") return; //帳票区分が"6"「退職書類」以外は何もしない
        switch (file.missingFormClass) {
          case "14":
            handleMissingFormClass14();
            break;
          case "10":
            handleMissingFormClass10();
            break;
          case "21":
            handleMissingFormClass21();
            break;
          case "22":
            handleMissingFormClass22();
            break;
        }
      });
    }

    if (context?.fileList) {
      context?.fileList.forEach((file: any) => {
        if (file.formKbn !== "6") return; //帳票区分が"6"「退職書類」以外は何もしない
        switch (file.formClass) {
          case "14":
            handleFormClass14(file);
            break;
          case "10":
            handleFormClass10(file);
            break;
          case "21":
            handleFormClass21(file);
            break;
          case "22":
            handleFormClass22(file);
            break;
        }
      });
    }

    setInfoManual(message);
    setStateTableList([...resArr]);

    function handleMissingFormClass14() {
      deathOrAutopsyReport.showLine = true;
      addMessage(infoManualRelationship1);
    }

    function handleMissingFormClass10() {
      if (context?.demanderRelationship === Relationship["内縁の妻又は夫"]) {
        marriageReport.showLine = true;
        addMessage(infoManualRelationship2);
      } else {
        if (context?.livelihoodFromRetireeFlg === "1") {
          yesLivelihoodInvestForm.showLine = true;
          addMessage(infoManualRelationship3);
        } else {
          noLivelihoodInvestForm.showLine = true;
          addMessage(infoManualRelationship4);
        }
      }
    }

    function handleMissingFormClass21() {
      certifiedCertificateResidence.showLine = true;
      addMessage(infoManualRelationship5);
    }

    function handleMissingFormClass22() {
      documentCertifyingSpouse.showLine = true;
      addMessage(infoManualRelationship6);
    }

    function handleFormClass14(file: any) {
      deathOrAutopsyReport.setDefaultValue = [
        {
          formName: file.formName,
          fileBase64: file.file,
        },
      ];
    }

    function handleFormClass10(file: any) {
      if (context?.demanderRelationship === Relationship["内縁の妻又は夫"]) {
        marriageReport.setDefaultValue = [
          {
            formName: file.formName,
            fileBase64: file.file,
          },
        ];
      } else {
        if (context?.livelihoodFromRetireeFlg === "1") {
          yesLivelihoodInvestForm.setDefaultValue = [
            {
              formName: file.formName,
              fileBase64: file.file,
            },
          ];
        } else {
          noLivelihoodInvestForm.setDefaultValue = [
            {
              formName: file.formName,
              fileBase64: file.file,
            },
          ];
        }
      }
    }

    function handleFormClass21(file: any) {
      certifiedCertificateResidence.setDefaultValue = [
        {
          formName: file.formName,
          fileBase64: file.file,
        },
      ];
    }

    function handleFormClass22(file: any) {
      documentCertifyingSpouse.setDefaultValue = [
        {
          formName: file.formName,
          fileBase64: file.file,
        },
      ];
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // バリデーションチェックを制御
  const ruleSchema = useMemo(() => {
    let schemaArr = JSON.parse(JSON.stringify(schema));
    let resArr = [...stateFakeTableList];

    //「死亡診断書」又は「死体検案書」（写）
    let deathOrAutopsyReport = resArr.find(
      (item) => item.keyword === "deathOrAutopsyReport"
    )!;
    if (!deathOrAutopsyReport.showLine) {
      delete schemaArr.deathOrAutopsyReport;
    }

    //内縁関係についての「生計維持に関する調査書」（様式１１号）
    let marriageReport = resArr.find(
      (item) => item.keyword === "marriageReport"
    )!;
    if (!marriageReport.showLine) {
      delete schemaArr.marriageReport;
    }

    //職員の死亡当時の世帯員の状況を明らかにできる「住民票の謄本」
    let certifiedCertificateResidence = resArr.find(
      (item) => item.keyword === "certifiedCertificateResidence"
    )!;
    if (!certifiedCertificateResidence.showLine) {
      delete schemaArr.certifiedCertificateResidence;
    }

    //その他、事実上の配偶者であることを証明する書類
    let documentCertifyingSpouse = resArr.find(
      (item) => item.keyword === "documentCertifyingSpouse"
    )!;
    if (!documentCertifyingSpouse.showLine) {
      delete schemaArr.documentCertifyingSpouse;
    }

    //職員の死亡当時、主として職員の収入により生計を維持していた親族がいることを証する「生計維持に関する調査書」（様式１１号）
    let yesLivelihoodInvestForm = resArr.find(
      (item) => item.keyword === "yesLivelihoodInvestForm"
    )!;
    if (!yesLivelihoodInvestForm.showLine) {
      delete schemaArr.yesLivelihoodInvestForm;
    }

    //職員の死亡当時、主として職員の収入により生計を維持していた親族がいないことを証する「生計維持に関する調査書」（様式１１号）
    let noLivelihoodInvestForm = resArr.find(
      (item) => item.keyword === "noLivelihoodInvestForm"
    )!;
    if (!noLivelihoodInvestForm.showLine) {
      delete schemaArr.noLivelihoodInvestForm;
    }

    return schemaArr;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateFakeTableList]);

  const makeFileObj = (obj: any) => {
    const formClassList: any = [
      FormClassRetire["「死亡診断書」又は「死体検案書」（写）"],
      FormClassRetire["生計維持に関する調査書（様式11号）"],
      FormClassRetire["職員の死亡当時の住民票の謄本"],
      FormClassRetire["事実上の配偶者であることを証明する書類"],
    ];
    let fileList =
      context?.fileList?.filter(
        (item) => !formClassList.includes(item.formClass)
      ) ?? [];

    const common = {
      facilityNo: context?.facilityNo,
      fileList_staffNo: context?.staffNo,
      formKbn: FormKbn["退職書類"],
    };

    if (obj.deathOrAutopsyReport) {
      fileList.push({
        ...common,
        formClass: FormClassRetire["「死亡診断書」又は「死体検案書」（写）"],
        formName: obj.deathOrAutopsyReport[0].formName,
        file: obj.deathOrAutopsyReport[0].fileBase64,
      });
    }
    if (obj.marriageReport) {
      fileList.push({
        ...common,
        formClass: FormClassRetire["生計維持に関する調査書（様式11号）"],
        formName: obj.marriageReport[0].formName,
        file: obj.marriageReport[0].fileBase64,
      });
    }

    if (obj.certifiedCertificateResidence) {
      fileList.push({
        ...common,
        formClass: FormClassRetire["職員の死亡当時の住民票の謄本"],
        formName: obj.certifiedCertificateResidence[0].formName,
        file: obj.certifiedCertificateResidence[0].fileBase64,
      });
    }
    if (obj.documentCertifyingSpouse) {
      fileList.push({
        ...common,
        formClass: FormClassRetire["事実上の配偶者であることを証明する書類"],
        formName: obj.documentCertifyingSpouse[0].formName,
        file: obj.documentCertifyingSpouse[0].fileBase64,
      });
    }
    if (obj.yesLivelihoodInvestForm) {
      fileList.push({
        ...common,
        formClass: FormClassRetire["生計維持に関する調査書（様式11号）"],
        formName: obj.yesLivelihoodInvestForm[0].formName,
        file: obj.yesLivelihoodInvestForm[0].fileBase64,
      });
    }
    if (obj.noLivelihoodInvestForm) {
      fileList.push({
        ...common,
        formClass: FormClassRetire["生計維持に関する調査書（様式11号）"],
        formName: obj.noLivelihoodInvestForm[0].formName,
        file: obj.noLivelihoodInvestForm[0].fileBase64,
      });
    }

    fileList.forEach((item, index) => {
      item.serialNo = index + 1;
    });

    return fileList;
  };

  const makeHttpObj = (obj: any): IAPI_RET005_Request => {
    const reqObj: IAPI_RET005_Request = {
      ...context,
      businessType: businessState.common?.businessType,
      tempSaveStep: 7,
      contractorNo,
      contractorName: businessState.common?.contractorName,
      fileList: makeFileObj(obj),
      screenId: "SCRR411125", // 画面ID
    };
    return API_RET005_BuildReqParams(reqObj);
  };

  const handleSubmit = async (data: any, index: any) => {
    switch (index) {
      case 0: // 一時保存
        // 退職手当金請求更新API実行
        try {
          const res = await httpAPI_RET005({
            ...makeHttpObj(data),
          });

          if (res.resultCd === "I0000") {
            setOpen(true);
            setBusinessState({
              ...businessState,
              job_41: {
                ...context,
                applyId: res.applyId,
                tempSaveStep: 7,
                fileList: makeFileObj(data),
              },
            });
            setState({
              ...state,
              errorMsgId: "",
            });
          } else {
            setOpen(false);
            setState({
              ...state,
              errorMsgId: res.resultCd,
            });
          }
        } catch (error) {
          navigate("/error");
        }
        break;

      case 1: // 次へ
        setBusinessState({
          ...businessState,
          job_41: {
            ...context,
            fileList: makeFileObj(data),
          },
        });

        navigate("/SCRR411126");
        break;
    }
  };

  return (
    <Box data-testid="SCRR411125PageForTest">
      <TkStepper
        steps={steps}
        activeStep={6}
        savaStep={context?.tempSaveStep}
      />
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLR411125_01}</TkInfoManual>
      <TkInfoManual rule={"<"}>{infoManual}</TkInfoManual>

      {isKiKo && (
        <TkContractorAndNumberLine
          name="退職者名"
          no={context?.retirementStaffName ?? ""}
        />
      )}

      <TkFakeTable
        list={stateTableList}
        ruleSchema={ruleSchema}
        submitButtonGroup={[
          { submitButtonText: "一時保存" },
          { submitButtonText: "次へ" },
        ]}
        buttonGroup={<TkBackButton />}
        onCheckAndSubmit={handleSubmit}
      />
      <TkMessageDialog
        open={open}
        onOky={() => setOpen(false)}
        title="一時保存完了"
        contextText="　一時保存が完了しました。"
        okText="はい"
        cancelText=""
      />
    </Box>
  );
};

export default SCRR411125;
